// projectChain: which projects a project sits inside.
//
// A nested project is only in the shell's tree once its PARENT's contents have
// arrived, so opening it has to wait for the parent's read, and for no one
// else's. The root list carries every project's parentId, which is enough to
// name that chain without asking the server.

export interface ParentLink {
  id: string;
  parentId?: string | null;
}

/** the ids above `id`, nearest first (parent, grandparent, …). Empty for a
 *  top-level or unknown project. A cycle in the data ends the walk rather than
 *  looping, and a long chain is cut at a sane depth. */
export function ancestorIds(projects: readonly ParentLink[], id: string, maxDepth = 12): string[] {
  const parentOf = new Map<string, string | null>();
  for (const p of projects) parentOf.set(p.id, p.parentId ?? null);
  const out: string[] = [];
  const seen = new Set<string>([id]);
  let cur = parentOf.get(id) ?? null;
  while (cur && !seen.has(cur) && out.length < maxDepth) {
    out.push(cur);
    seen.add(cur);
    cur = parentOf.get(cur) ?? null;
  }
  return out;
}
